// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://swxtouquqpdruxfzxdnt.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN3eHRvdXF1cXBkcnV4Znp4ZG50Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM0MjU1ODAsImV4cCI6MjA2OTAwMTU4MH0.NvjpF91zGCRJvzG-RActxWqTkaHcGr2wsY0cQCFoq60";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});